// extracted by mini-css-extract-plugin
export default {"contentStyle":"OutOfCreditsModal_contentStyle__KYcnU","container":"OutOfCreditsModal_container__JivbI","footer":"OutOfCreditsModal_footer__aSvDH"};